module.exports = __webpack_public_path__ + "assets/place-min.b6cf7783201cd64d00bdb3a77c3f6bb7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/place-min.png
 ** module id = 123
 ** module chunks = 0
 **/